// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-search{transition:height .3s ease-in-out,padding-top .3s ease-in-out,padding-bottom .3s ease-in-out;padding-bottom:10px}", ""]);
// Exports
module.exports = exports;
